// One source of truth for product availability, shared by Catalog cards and
// the PDP. Multi-variant rule matches user intent verbatim:
//
//     "One variant being OOS doesn't shut down the entire product card."
//
// If the product has variants, variant-level in_stock is the ONLY signal —
// product-level `in_stock` is ignored so an admin/supplier flip on a single
// mg (e.g. Tesa-10mg went OOS) never blacks out the whole card while other
// variants remain buyable. Fall back to product-level only for no-variant
// products.
export const isProductOutOfStock = (p) => {
  const variants = Array.isArray(p?.variants)
    ? p.variants.filter((v) => v && v.price != null)
    : [];
  if (variants.length > 0) {
    return variants.every((v) => v.in_stock === false);
  }
  return p?.in_stock === false;
};
